import { Autocomplete, Checkbox, Chip, Typography } from "@mui/material";

import { CoAppDialogTooltipContainer, CoAppDialogTooltipText, CoAppLightTooltip } from "../../styled/global.styled";
import CoAppTextField from "./CoAppTextField";

export default function CoAppMultiSelect(props) {
	const {
		options, value, onChange,
		label, placeholder, disabled,
		isFreeSolo, customStyles, hasToolTip,
		chipSize, rawOptions = [], customRenderTags = null,
		customRenderCheckboxes = null, textFieldWidth = "100%", customRenderOptionLabel = null,
		limitTags = null, error, helperText,
		// Outlined pill is now the default to match the rest of the input
		// system. Callers can override to "standard" if they specifically
		// want the underline style, but no surface in the redesign uses it.
		/** @type {import("@mui/material/TextField").TextFieldProps["variant"]} */
		textFieldVariant = "outlined",
		/** @type {import("@mui/material/TextField").TextFieldProps["margin"]} */
		textFieldMargin = "none",
		...rest
	} = props;
	const handleCheckboxRenderOptions = (props, option, { selected }) => {
		const { key, ...optionProps } = props;
		const optionLabel = typeof option === "string" ? option : String(option ?? "");
		const matched = rawOptions.find((item) => item.name === optionLabel);

		return (
			<li key={key ?? optionLabel} {...optionProps}>
				<Checkbox
					style={{ marginRight: 8 }}
					checked={selected}
					value={option}
				/>
				<div style={{ display: "block" }}>
					{!optionLabel.includes("@") ? optionLabel : null} {/* If the option is an email (meaning name is not available), we don't show it */}
					<Typography variant="body2" color="text.secondary">{hasToolTip ? matched?.email ?? null : null}</Typography>
				</div>
			</li>
		);
	};

	const handleRenderTags = (tagValue, getTagProps) => {
		return tagValue.map((option, index) => {
			const optionLabel = typeof option === "string" ? option : String(option ?? "");
			const matched = rawOptions.find((item) => item.name === optionLabel);
			const name = matched?.name ?? optionLabel;
			const email = matched?.email ?? "";
			const { key, ...tagProps } = getTagProps({ index });
			const showSplitTooltip = Boolean(matched) && name !== email;
			return (
				<CoAppLightTooltip
					key={key}
					title={
						showSplitTooltip ?
							<CoAppDialogTooltipContainer>
								<CoAppDialogTooltipText name="true">{name}</CoAppDialogTooltipText>
								<CoAppDialogTooltipText>{email}</CoAppDialogTooltipText>
							</CoAppDialogTooltipContainer>
							:
							null
					}
				>
					<Chip {...tagProps} label={showSplitTooltip ? name : (matched ? (name !== email ? name : email) : optionLabel)} />
				</CoAppLightTooltip>
			);
		});
	};

	return (
		<Autocomplete
			{...rest}
			sx={customStyles}
			freeSolo={isFreeSolo}
			multiple
			disableCloseOnSelect
			fullWidth
			limitTags={limitTags ? limitTags : 10}
			options={options}
			value={value}
			onChange={onChange}
			disabled={disabled}
			getOptionLabel={customRenderOptionLabel !== null ? customRenderOptionLabel : (option) => option}
			renderInput={(params) => (
				<CoAppTextField
					{...params}
					variant={textFieldVariant}
					margin={textFieldMargin}
					label={label}
					placeholder={placeholder}
					error={error}
					helperText={helperText}
					FormHelperTextProps={{ style: { color: "#DE3730" } }}
					sx={{ width: textFieldWidth, backgroundColor: "transparent" }}
				/>
			)}
			renderOption={!isFreeSolo ? customRenderCheckboxes !== null ? customRenderCheckboxes : handleCheckboxRenderOptions : null}
			slotProps={{ chip: { size: chipSize || "medium" } }}
			renderValue={hasToolTip ? customRenderTags !== null ? customRenderTags : handleRenderTags : null}
		/>
	);
}
